/**
 * Chrome del panel admin: sidebar de secciones + header con la cuenta. Vive
 * FUERA del "device" de 480px (App lo monta a ancho completo): es una
 * herramienta interna, no la app de padres/niños. Las secciones cuelgan del
 * <Outlet/>. Las secciones 6–8 (banco, licencias, config) llegan en el 2º PR.
 */
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext.js";
import s from "./admin.module.css";

interface Seccion {
  to: string;
  label: string;
  end?: boolean;
  soon?: boolean;
}

const SECCIONES: Seccion[] = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/usuarios", label: "Usuarios" },
  { to: "/admin/ninos", label: "Niños" },
  { to: "/admin/evaluaciones", label: "Evaluaciones" },
  { to: "/admin/banco", label: "Banco de Palabras" },
  { to: "/admin/creditos", label: "Créditos y ventas" },
  { to: "/admin/config", label: "Configuración" },
];

export function AdminLayout() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();

  async function salir() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <div className={s.shell}>
      <nav className={s.sidebar}>
        <div className={s.brand}>
          VoiceCheck
          <small>ADMIN</small>
        </div>
        {SECCIONES.map((sec) => (
          <NavLink
            key={sec.to}
            to={sec.to}
            end={sec.end ?? false}
            className={({ isActive }) => `${s.navlink} ${isActive ? s.navactive : ""}`}
          >
            {sec.label}
            {sec.soon ? <span className={s.soon}>PRONTO</span> : null}
          </NavLink>
        ))}
      </nav>

      <div className={s.main}>
        <header className={s.header}>
          <span className={s.headerTitle}>Panel de administración</span>
          <span className={s.headerSpacer} />
          <span className={s.headerUser}>
            {usuario?.nombre} · {usuario?.email}
          </span>
          <button className={s.btn} onClick={() => void salir()}>
            Salir
          </button>
        </header>
        <main className={s.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
